import { radioPropsBase } from './radio.mjs';
import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const radioButtonProps = buildProps({
  ...radioPropsBase
});

export { radioButtonProps };
//# sourceMappingURL=radio-button2.mjs.map
